export default "__VITE_ASSET__DhrRPUNZ__"